(function (global) {
    if (global.rlModule.rlBannerModule) {
        console.log('rlBannerModule is already defined!');
        return;
    }
    global.rlModule.rlBannerModule = (function () {
        var _module = {};
        var scriptPath = { contentPageJS: "/includes/script/modules/ContentPage.js" };

        _module.ready = $(document).ready(function () {
            rlModule.rlBannerModule.intialBannerTemplate();
        });

        _module.intialBannerTemplate = function () {
            var windowSize = window.innerWidth;

            if ($("._fetchPID").length > 0) {
                loadScript();
            }

            setPromoLabelColor();
            addPackIncludeListImage();

            $(window).on('load resize', function () {
                windowSize = window.innerWidth;
                if (windowSize <= 767) {
                    setFontSize(767, 1, windowSize);
                    setImageSize(767, 0.8, windowSize);
                }
                else {
                    setFontSize(1920, 1, windowSize);
                    setImageSize(1920, 1, windowSize);
                }
                setBannerHeightInMobileSize(windowSize);
                resetRowWidthWithLabel(windowSize);
            });
        }

        var setBannerHeightInMobileSize = function (windowSize) {
            try {
                $(".rl-banner").each(function (index, obj) {
                    var settings;
                    var height;
                    var backgroundColor;
                    var ratio = 0;

                    if ($(obj).data("mobile-setting") != null) {
                        settings = $(obj).data("mobile-setting").toString().split(',');
                        height = settings[0];
                        backgroundColor = settings[1];

                        if (windowSize <= 767) {
                            $(obj).css({
                                "height": ((height / 767) * 100) + "vw",
                                "background-color": backgroundColor
                            });
                        }
                        else {
                            $(obj).css({
                                "height": "",
                            });
                        }
                    }
                });
            } catch (e) {
                console.log(e);
            }
        }

        var resetRowWidthWithLabel = function (windowSize) {
            $(".rl-banner").find(".rl-promo-label").each(function (index, obj) {
                var target = $(obj).parent(".rl-banner").find(".rl-row-1440.rl-3x3");
                if (windowSize > 767) {
                    target.css("margin", "0 calc(12.1% + 15px)");
                }
                else {
                    target.css("margin", "0 15px");
                }
            });
        }

        var setPromoLabelColor = function () {
            $(".rl-promo-label.type-triangle").each(function (index, obj) {
                var color = $(obj).data("label-color");
                if (color != null) {
                    if ($(obj).hasClass("position-right")) {
                        $(obj).css({
                            "border-color": 'transparent' + " " + color + " " + 'transparent transparent'
                        });
                    }
                    else {
                        $(obj).css({ "border-color": color + ' ' + 'transparent transparent' });
                    }
                }
            });
        }

        var addPackIncludeListImage = function () {
            $(".rl-banner .rl-banner-packinclude").find(".type-image").each(function (index, obj) {
                var imageUrl = $(obj).data("list-image");
                $(obj).find("li").prepend("<img src='" + imageUrl + "'>");
            });
        }

        var setImageSize = function (viewWidth, ratio, windowSize) {
            $(".rl-banner .rl-3x3").find("img").each(function (index, obj) {
                if ($(obj).hasClass("main-title") && (windowSize <= 767)) {
                    $(obj).css("width", "");
                }
                else {
                    var imgWidth;
                    var theImage = new Image();
                    theImage.src = $(obj).attr("src");
                    $(theImage).on('load', function () {
                        imgWidth = theImage.width;
                        $(obj).css("width", ((imgWidth * ratio) / viewWidth) * 100 + "vw");
                    });
                };
            });
        }

        var setFontSize = function (viewWidth, ratio, windowSize) {
            try {
                $(".rl-banner .rl-3x3").find(".data_font_size").each(function (index, obj) {
                    if ($(obj).data("font-size") != null) {
                        var fontSizeArray = $(obj).data("font-size").toString().split(',');
                        var fontSizeSetting;

                        if (fontSizeArray.length > 0 && fontSizeArray.length != 1) {
                            if (windowSize <= 767) {
                                fontSizeSetting = parseInt(fontSizeArray[0]);
                                $(obj).css("font-size", ((fontSizeSetting * ratio) / viewWidth) * 100 + "vw");
                            }
                            else {
                                fontSizeSetting = parseInt(fontSizeArray[1]);
                                $(obj).css("font-size", ((fontSizeSetting * ratio) / viewWidth) * 100 + "vw");
                            }
                        }
                        else if (fontSizeArray.length > 0 && fontSizeArray.length == 1) {
                            fontSizeSetting = parseInt(fontSizeArray[0]);
                            $(obj).css("font-size", ((fontSizeSetting * ratio) / 1920) * 100 + "vw");
                        }

                        var currentFontSize = parseInt($(obj).css('font-size').replace('px', ''));

                        if ($(obj).data("keep-scale") == 1) {
                            if (currentFontSize <= 12) {
                                var scale = ((fontSizeSetting * windowSize) / viewWidth) / 12;
                                $(obj).css({
                                    '-webkit-transform': 'scale(' + scale + ')',
                                    '-ms-transform': 'scale(' + scale + ')',
                                    'transform': 'scale(' + scale + ')',
                                    '-webkit-transform-origin': 'left top',
                                    '-ms-transform-origin': 'left top',
                                    'transform-origin': 'left top'
                                });
                            }
                            else {
                                $(obj).css({
                                    '-webkit-transform': '',
                                    '-ms-transform': '',
                                    'transform': '',
                                    '-webkit-transform-origin': '',
                                    '-ms-transform-origin': '',
                                    'transform-origin': ''
                                });
                            }
                        }
                    }
                });
            } catch (e) {
                console.log(e);
            }
        }

        var loadScript = function () {
            $.getScript(scriptPath.contentPageJS)
                .then(function () {

                }).fail(function () {
                    console.log('load js fail.');
                });
        }

        return _module;
    })();
})(window);
